<!-- <div class="text-center my-5 app-loader-simple" [class.mt-5]="!simple">
    <svg class="pl" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
        <defs>
            <linearGradient id="pl-grad1" x1="1" y1="0.5" x2="0" y2="0.5">
                <stop offset="0%" stop-color="#e6ff00" />
                <stop offset="100%" stop-color="#e6ff00" />
            </linearGradient>
            <linearGradient id="pl-grad2" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stop-color="#e6ff00" />
                <stop offset="100%" stop-color="#e6ff00" />
            </linearGradient>

            <linearGradient id="pl-grad3" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stop-color="#e6ff00" />
                <stop offset="100%" stop-color="#e6ff00" />
            </linearGradient>
        </defs>
        <line
            class="pl__ball2"
            stroke="url(#pl-grad3)"
            x1="100"
            y1="18"
            x2="100.01"
            y2="182"
            stroke-width="36"
            stroke-dasharray="1 165"
            stroke-linecap="round"
        />
        <circle
            class="pl__ring"
            cx="100"
            cy="100"
            r="82"
            fill="none"
            stroke="url(#pl-grad1)"
            stroke-width="36"
            stroke-dasharray="0 257 1 257"
            stroke-dashoffset="0.01"
            stroke-linecap="round"
            transform="rotate(-90,100,100)"
        />
        <line
            class="pl__ball"
            stroke="url(#pl-grad2)"
            x1="100"
            y1="18"
            x2="100.01"
            y2="182"
            stroke-width="36"
            stroke-dasharray="1 165"
            stroke-linecap="round"
        />
    </svg>

 
</div> -->
<div class="text-center app-loader-simple">
    <svg width="200" height="240" viewBox="0 0 100 120" xmlns="http://www.w3.org/2000/svg">
        <defs>
            <pattern id="soccerTile" x="0" y="0" width="10" height="10" patternUnits="userSpaceOnUse">
                <rect width="10" height="10" fill="white" />
                <path d="M5 1.5 L8 3.5 L7 7.5 L3 7.5 L2 3.5 Z" fill="#222" />
                <path
                    d="M5 0 V1.5 M8 3.5 L10 2.5 M7 7.5 L8.5 10 M3 7.5 L1.5 10 M2 3.5 L0 2.5"
                    fill="none"
                    stroke="#ddd"
                    stroke-width="0.5"
                />
            </pattern>

            <clipPath id="ballClip">
                <circle cx="10" cy="10" r="9" />
            </clipPath>

            <linearGradient id="loadingGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" stop-color="#fff">
                    <animate attributeName="offset" values="-1; 1" dur="2s" repeatCount="indefinite" />
                </stop>
                <stop offset="50%" stop-color="#000">
                    <animate attributeName="offset" values="-0.5; 1.5" dur="2s" repeatCount="indefinite" />
                </stop>
                <stop offset="100%" stop-color="#fff">
                    <animate attributeName="offset" values="0; 2" dur="2s" repeatCount="indefinite" />
                </stop>
            </linearGradient>
        </defs>

        <style>
            .bouncer {
                animation: bounce 0.6s cubic-bezier(0.3, 0.45, 0.15, 1) infinite alternate;
                transform-origin: 50px 85px;
            }
            .shadow-new {
                fill: rgba(0, 0, 0, 0.15);
                animation: shadow-scale-new 0.6s cubic-bezier(0.3, 0.45, 0.15, 1) infinite alternate;
                transform-origin: center;
            }
            .ball-container {
                animation: switch-sport 4.8s step-end infinite;
            }
            .spinning {
                animation: rotate-all 1.2s linear infinite;
                transform-origin: 10px 10px;
            }

            @keyframes bounce {
                from {
                    transform: translateY(0) scale(1.18, 0.82);
                }
                to {
                    transform: translateY(-45px) scale(1, 1);
                }
            }
            @keyframes shadow-scale-new {
                from {
                    transform: scaleX(1.4);
                    opacity: 1;
                }
                to {
                    transform: scaleX(0.4);
                    opacity: 0.2;
                }
            }
            @keyframes switch-sport {
                0% {
                    transform: translateX(0);
                }
                25% {
                    transform: translateX(-100px);
                }
                50% {
                    transform: translateX(-200px);
                }
                75% {
                    transform: translateX(-300px);
                }
            }
            @keyframes rotate-all {
                from {
                    transform: rotate(0deg);
                }
                to {
                    transform: rotate(360deg);
                }
            }
        </style>

        <ellipse class="shadow-new" cx="50" cy="85" rx="14" ry="3" />

        <g class="bouncer">
            <svg x="40" y="50" width="20" height="40" viewBox="0 0 20 40">
                <g class="ball-container">
                    <g transform="translate(0, 15)">
                        <circle cx="10" cy="10" r="9" fill="white" stroke="#222" stroke-width="0.2" />
                        <g clip-path="url(#ballClip)">
                            <rect class="spinning" x="-10" y="-10" width="40" height="40" fill="url(#soccerTile)" />
                        </g>
                        <circle cx="10" cy="10" r="9" fill="none" stroke="#222" stroke-width="0.4" />
                    </g>

                    <g transform="translate(100, 15)">
                        <g class="spinning">
                            <circle cx="10" cy="10" r="9" fill="#FF8C00" stroke="#222" stroke-width="0.5" />
                            <path
                                d="M1 10 H19 M10 1 V19 M3 4.5 Q10 10 3 15.5 M17 4.5 Q10 10 17 15.5"
                                fill="none"
                                stroke="#222"
                                stroke-width="0.8"
                            />
                        </g>
                    </g>

                    <g transform="translate(200, 15)">
                        <g class="spinning">
                            <circle cx="10" cy="10" r="9" fill="#D4FF12" stroke="#A0C410" stroke-width="0.3" />
                            <path
                                d="M3 6 Q10 10 3 14 M17 6 Q10 10 17 14"
                                fill="none"
                                stroke="#FFF"
                                stroke-width="1.2"
                                stroke-linecap="round"
                            />
                        </g>
                    </g>

                    <g transform="translate(300, 15)">
                        <g class="spinning">
                            <circle cx="10" cy="10" r="9" fill="#D00" stroke="#800" stroke-width="0.5" />
                            <circle cx="7" cy="7" r="2.5" fill="white" opacity="0.4" />
                        </g>
                    </g>
                </g>
            </svg>
        </g>

        <text
            x="50"
            y="110"
            font-family="Arial, sans-serif"
            font-weight="bold"
            font-size="8"
            text-anchor="middle"
            fill="url(#loadingGradient)"
        >
            Loading...
        </text>
    </svg>
</div>
